export function setEditorToReadOnly() {
  const editorContent = document.querySelector(".editor-content");
  const saveButton = document.getElementById("save");
  const publishButton = document.getElementById("publish");

  if (editorContent) {
    editorContent.style.pointerEvents = "none";
  }
  if (saveButton) {
    saveButton.style.display = "none";
  }
  if (publishButton) {
    publishButton.style.pointerEvents = "none";
  }
}

export function removeEditorReadOnlyFlag() {
  const editorContent = document.querySelector(".editor-content");
  const saveButton = document.getElementById("save");
  const publishButton = document.getElementById("publish");

  if (editorContent) {
    editorContent.style.pointerEvents = "all";
  }
  if (saveButton) {
    saveButton.style.display = "block";
  }
  if (publishButton) {
    publishButton.style.pointerEvents = "all";
  }
}
